const LEVEL_KEYS = ['subjects', 'guides', 'themes', 'topics', 'subtopics'];

/**
 * Builds a teacher-scoped adaptive report drilldown URL. Pass `classroomId` to scope the report to a
 * single class (inserts a `classrooms/<id>` segment after the teacher, matching the report URL parser).
 *
 * `userId` must be masquerade-aware — reports are data, so they follow the acted-as teacher, not the
 * real admin. It is a parameter rather than a `masqueradeStore` read here because callers render this
 * URL during render under the React Compiler, which would cache a store read and strand the URL on
 * the pre-masquerade teacher; bridge it with `useFluxStore(masqueradeStore, …)` at render call sites.
 */
export const buildReportURLFromLevels = (
  ids: (string | undefined)[],
  userId: string | null | undefined,
  classroomId?: string
): string => {
  const base = classroomId
    ? `/reports/teachers/${userId}/classrooms/${classroomId}`
    : `/reports/teachers/${userId}`;

  const pathSegments = ids.slice(0, LEVEL_KEYS.length).reduce<string[]>(
    (acc, id, index) => {
      if (!id) {
        return acc;
      }
      return [...acc, LEVEL_KEYS[index], id];
    },
    [base]
  );

  return pathSegments.join('/');
};
